module.exports = function (app) {
    app.constant('appSchemas', {
        employeeForm: {
            blue: 'string&isBlue',
            optional: 'string&optional',
            notInData: 'string',
            NaN: 'NaN',
            infinity: 'infinity',
            //objectNum: 'number',
            //function: 'function',
            alpha: 'string&char:alpha',
            numeric: 'string&char:numeric',
            alphanumeric: 'string&char:alphanumeric,required',
            employeeId: "string&required,numeric",
            subscriber: {
                cobra: 'string',
                hireDate: 'date',
                coverageEffDate: 'date',
                address: {
                    address1: 'string&required,char:alphanumeric',
                    address2: 'string&required,char:alphanumeric',
                    state: 'string&required,char:alpha',
                    city: 'string&required',
                    zipCode: {
                        base: 'string'
                    }
                },
                phone: {
                    home: 'string',
                    work: 'string',
                    mobile: 'string',
                    fax: 'string'
                },
                tobaccoStatus: '',
                workEmail: 'string'
            },
            dependents: [
                {
                    subscriber: 'string',
                    fullName: {
                        prefix: 'string',
                        first: 'string',
                        middle: 'string',
                        last: 'string',
                        suffix: 'string'
                    },
                    ssn: 'string',
                    gender: 'string',
                    birthDate: 'date',
                    relationship: "string",
                    specialStatus: 'string',
                    otherInsuranceShow: 'string',
                    otherInsurance: {
                        custody: 'string',
                        insuranceCarrier: 'string',
                        groupNumber: 'string',
                        policyHolderFirstName: 'string',
                        policyHolderLastName: 'string',
                        effectiveDate: 'string',
                        cancelDate: 'string',
                        policyNumber: 'string',
                        relationSubscriber: 'string',
                        policyHolderBirthDate: 'string',
                        policyHolderEmploymentStatus: 'string'
                    },
                    medicareEligibleShow: 'string',
                    medicareEligible: {
                        claimNumber: 'string',
                        whyEligible: 'string',
                        ssdi: 'string',
                        ssdiDates: {
                            startDate: 'string',
                            endDate: 'string'
                        },
                        partA: {
                            startDate: 'string',
                            endDate: 'string'
                        },
                        partB: {
                            startDate: 'string',
                            endDate: 'string'
                        },
                        partC: 'string',
                        partCInfo: {
                            carrierName: 'string',
                            policyNumber: 'string',
                            groupNumber: 'string',
                            effectiveDate: {
                                startDate: 'string',
                                endDate: 'string'
                            }
                        },
                        partD: 'string',
                        partDInfo: {
                            carrierName: 'string',
                            policyNumber: 'string',
                            groupNumber: 'string',
                            effectiveDate: {
                                startDate: 'string',
                                endDate: 'string'
                            },
                            bin: 'string',
                            pcn: 'string'
                        },
                    },
                    planCoverage: {
                        medical: 'string',
                        dental: 'string',
                        vision: 'string',
                        drug: 'string',
                        service: 'string'
                    },
                    provider: {
                        number: 'string',
                        name: 'string',
                        establishedPatient: 'string',
                        effectiveDate: 'string',
                        reason: 'string'
                    }
                }
            ],
            planCoverage: [
                {
                    label: "string",
                    effectiveDate: "string",
                    plan: "string",
                },
                {
                    label: "string",
                    effectiveDate: "string",
                    plan: "string",
                },
                {
                    label: "string",
                    effectiveDate: "string",
                    plan: "string",
                },
                {
                    label: "string",
                    effectiveDate: "string",
                    plan: "string",
                },
                {
                    label: "string",
                    effectiveDate: "string",
                    plan: "string",
                }
            ]
        }
    })
};


